import router from 'next/router'
import { useCallback, useEffect } from 'react'
import { LOCALSTORAGE_KEY_ORIGINAL_LOCATION } from '../../constants'
import { useCurrency } from '../../providers/currency'
import { useStore } from '../../providers/store'
import { removeTrailingSlashes } from '../../utils/url'
import { getNextHourDate } from '../../utils/date'
import { useLocalStorage } from '../useLocalStorage'
import { useConfig } from '../../providers/config'
import { getTrackingHandler } from '../../trackings/trackings'

export const useTrackingsInit = ({ trackings, setTrackings }) => {
	const config = useConfig()
	const { code: storeCode, uri: storeUri } = useStore()

	const { currency } = useCurrency()

	const [storageValueOriginalLocation, setStorageValueOriginalLocation] = useLocalStorage(
		LOCALSTORAGE_KEY_ORIGINAL_LOCATION,
		''
	)

	const getOriginalLocation = useCallback(() => {
		const originalLocation =
			storageValueOriginalLocation ||
			(storeUri ? removeTrailingSlashes(storeUri) + router.asPath : window.location.href)
		setStorageValueOriginalLocation(originalLocation, getNextHourDate())
		return originalLocation
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const init = useCallback(async () => {
		const updatedTrackings = []
		if (process.env.NEXT_PUBLIC_BH_TRACKINGS === '1') {
			for (const tracking of trackings) {
				if (!tracking.initialized) {
					// const trackingHandler = await import(`../../trackings/${tracking.id}/index.js`)
					const trackingHandler = await getTrackingHandler(tracking.id)
					const handler = trackingHandler?.default ?? trackingHandler
					try {
						await handler.init({
							config,
							apiUrl: tracking.apiUrl,
							code: tracking.code,
							storeCode,
							currencyCode: currency,
							originalLocation: getOriginalLocation(),
						})
						updatedTrackings.push({ ...tracking, ready: true, initialized: true, handler })
					} catch (error) {
						updatedTrackings.push({ ...tracking, initialized: true })
						console.error(`Tracking with ID ${tracking.id} failed to load`, error)
					}
				} else {
					updatedTrackings.push(tracking)
				}
			}
		}

		if (updatedTrackings.length > 0) {
			setTrackings(updatedTrackings)
		}
	}, [setTrackings, trackings, storeCode, currency, getOriginalLocation, config])

	useEffect(() => {
		init()
	}, [init])
}
